import axios from "axios";

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience, so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token",
    );
}

/**
 * 419 CSRF recovery interceptor.
 *
 * When an axios request returns 419 (token mismatch), fetch a fresh token via
 * the /csrf-token endpoint and retry the original request once. This covers
 * XHR-driven flows where the token aged between page load and the request.
 *
 * refreshCsrfToken() is defined in csrf.js, which app.js imports after axios.js.
 * The reference is resolved lazily at call time so import order is not an issue.
 *
 * Note: Livewire uses its own fetch transport and its own token refresh; this
 * interceptor only governs window.axios calls.
 */
window.axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { response, config } = error;

        if (
            response &&
            response.status === 419 &&
            config &&
            !config._csrfRetried
        ) {
            config._csrfRetried = true;

            try {
                const token =
                    typeof window.refreshCsrfToken === "function"
                        ? await window.refreshCsrfToken()
                        : null;

                if (token) {
                    config.headers = config.headers || {};
                    config.headers["X-CSRF-TOKEN"] = token;

                    return window.axios.request(config);
                }
            } catch (e) {
                // Refresh failed - fall through to reject with original error.
            }
        }

        return Promise.reject(error);
    },
);
